const translations = {
  es: {
    availability: "Disponibilidad",
    service: "Servicio",
    booking: "Reservas",
    profile: "Perfil",
    logout: "Cerrar sesión",
    language: "Idioma",
    operator: "🌍 Operador"
  },
  en: {
    availability: "Availability",
    service: "Service",
    booking: "Bookings",
    profile: "Profile",
    logout: "Logout",
    language: "Language",
    operator: "🌍 Operator"
  }
};

export default translations